
// file Route & run app adminPanel
import routing from './courseFront.route';
import run from './courseFront.run';

// controllers & services module Levels
import minorHalfController from './minor-half/view/minorHalfController';
import olderNurseryController from './older-nursery/view/olderNurseryController';
import middleMinorController from './middle-minor/view/middleMinorController';
import middleMajorController from './middle-major/view/middleMajorController';
import transitionOneController from './transition-one/view/transitionOneController';
import transitionDosController from './transition-dos/view/transitionDosController';
import modalEvaluationController from './modal-evaluation-students/modalEvaluationController';
import modalPowerBiController from './modal-power-bi/modalPowerBiController';
import studentsServices from '../admin-panel/students/studentsServices'
import ambitsServices from '../admin-panel/ambits/ambitsServices'
import coresServices from '../admin-panel/cores/coresServices'
import evaluationsServices from './minor-half/minorHalfServices'


import { listFilter } from '../../components/list-filter'


export default angular.module('app.courseFront', [studentsServices, ambitsServices, coresServices, evaluationsServices])
  .config(routing)
  .controller('minorHalfController', minorHalfController)
  .controller('modalEvaluationController', modalEvaluationController)
  .controller('olderNurseryController', olderNurseryController)
  .controller('middleMinorController', middleMinorController)
  .controller('middleMajorController', middleMajorController)
  .controller('transitionOneController', transitionOneController)
  .controller('transitionDosController', transitionDosController)
  .controller('modalPowerBiController', modalPowerBiController)
  .component('listFilter',listFilter)
  .run(run)
  .constant("courseFront", [{

    "title": "Niveles",
    "icon":"mdi-clipboard-flow mdi-light",
    "subMenu":[  
      {  
        "title":"Sala Cuna Menor",
        // "icon":"mdi-clipboard-flow",
        "url":"app.minorHalf"
      },
	  {  
        "title":"Sala Cuna Mayor",
        "url":"app.olderNursery"
      },
	  {  
        "title":"Medio Menor",
        "url":"app.middleMinor"
      },
	  {  
        "title":"Medio Mayor",
        "url":"app.middleMajor"
      },
	  {  
        "title":"Transición 1",
        "url":"app.transitionOne"
      },
	  {  
        "title":"Transición 2",
        "url":"app.transitionDos"
      }
	]
}])
.name;


// WEBPACK FOOTER //
// ./src/app/course-front/index.js